import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import withContextualSidebar from '../../ContextualSidebar/ContextualSidebarContainer';
import { SectionTitle } from '../../ContextualSidebar/SectionTitleStyle';
import { PrimaryButton } from '../../CommonComponents/Button';
import LoadingMask from '../../CommonComponents/LoadingMask';
import { setIsEnrollModalOpen } from '../ExperianActions';
import { isFetchingSubscribersSelector, subscribersSelector } from '../ExperianSelector';
import { currentRouteSelector } from '../../CommonComponents/Router/Selector';
import {
  LinkButton,
  LinkItem,
  Links,
  Wrapper,
} from '../../ContextualSidebar/SectionSidebar/SectionSidebarStyles';

export const LoadingView = styled.div`
  width: 100%;
`;

export const Footer = styled.div`
  margin-top: 16px;
  display: flex;

  > * {
    width: 100%;
  }
`;

const Sidebar = () => {
  const subscribers = useSelector(subscribersSelector);
  const currentRoute = useSelector(currentRouteSelector);
  const isFetchingSubscribers = useSelector(isFetchingSubscribersSelector);

  const dispatch = useDispatch();
  const openEnrollModal = useCallback(() => {
    dispatch(setIsEnrollModalOpen(true));
  }, [dispatch]);

  if (isFetchingSubscribers) {
    return (
      <Wrapper>
        <SectionTitle>Members Enrolled</SectionTitle>
        <Links>
          <LinkItem>
            <LoadingMask isDark height="53px" />
          </LinkItem>
          <LinkItem>
            <LoadingMask isDark height="53px" />
          </LinkItem>
          <LinkItem>
            <LoadingMask isDark height="53px" />
          </LinkItem>
        </Links>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <SectionTitle>Members Enrolled</SectionTitle>
      <Links>
        {subscribers.map(
          ({ SubscriberNumber: subscriberId, FirstName: firstName, LastName: lastName }) => (
            <LinkItem key={subscriberId}>
              <LinkButton
                isActive={currentRoute.params.subscriberId === subscriberId}
                onClick={() =>
                  ADV.util.Router.go2('Experian', {
                    clientId: currentRoute.params.clientId,
                    subscriberId,
                  })
                }
              >
                {`${firstName} ${lastName}`}
              </LinkButton>
            </LinkItem>
          ),
        )}
      </Links>
      <Footer>
        <PrimaryButton onClick={openEnrollModal}>New Enrollment</PrimaryButton>
      </Footer>
    </Wrapper>
  );
};

export default withContextualSidebar(Sidebar);
